import { render, staticRenderFns } from "./page2.vue?vue&type=template&id=7fc43f8e&scoped=true&"
import script from "./page2.vue?vue&type=script&lang=js&"
export * from "./page2.vue?vue&type=script&lang=js&"
import style0 from "./page2.vue?vue&type=style&index=0&id=7fc43f8e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc43f8e",
  null
  
)

export default component.exports